export default [
	{ name: "Canadian", code: "CAD", sign: "$", number:124 },
	{ name: "American", code: "USD", sign: "$", number:840 },
	{ name: "Euro", code: "EUR", sign: "€", number:978 },
	{ name: "Pound Sterling", code: "GBP", sign: "£", number:826 },

]